import React from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";

import COLOR_THEMES from "../../../colorThemes";


const UiIcon = (props) => {

  const {activeTheme, icon, color} = props;

  switch (icon) {
    case "checkmark":
      return (
        <svg width="43px" height="37px" viewBox="0 0 43 37" version="1.1" xmlns="http://www.w3.org/2000/svg">
          <g fill={color || COLOR_THEMES[activeTheme].active}>
            <path d="M8.75735931,31.2426407 C11.0620726,33.547354 14.7851807,33.5906401 17.1428545,31.3401333 L39.1428545,10.3401333 C41.5398439,8.05209791 41.6281686,4.25413493 39.3401333,1.85714552 C37.0520979,-0.539843895 33.2541349,-0.628168615 30.8571455,1.65986674 L14,18.9999994 L10.2426407,15.7573593 C7.89949494,13.4142136 4.10050506,13.4142136 1.75735931,15.7573593 C-0.585786438,18.1005051 -0.585786438,21.8994949 1.75735931,24.2426407 L8.75735931,31.2426407 Z" id="path-1"/>
          </g>
        </svg>
      )
    default:
      return null
  }
}

UiIcon.propTypes = {
  icon: PropTypes.string.isRequired,
  color: PropTypes.string
}

const mapStateToProps = store => {
  const {activeTheme} = store.serverState;
  return {
    activeTheme
  }
};

export default connect(mapStateToProps)(UiIcon)
